import { useNavigate } from "react-router-dom";
import { Logo, LogoLockup } from "../components/Logo";
import AmbientBackdrop from "../components/AmbientBackdrop";
import { ArrowRight, Sparkles } from "lucide-react";

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="mm-frame relative bg-navy text-white flex flex-col" data-testid="landing-page">
      <AmbientBackdrop dark />
      <div className="relative z-10 flex-1 flex flex-col px-7 pt-10 pb-10">
        <LogoLockup width={150} light />

        <div className="flex-1 flex flex-col justify-center mt-4">
          <div className="inline-flex items-center gap-2 self-start bg-white/10 border border-white/15 rounded-full px-3 py-1.5 text-xs font-semibold text-turq mb-6">
            <Sparkles size={13} /> Mental training for athletes
          </div>
          <h1 data-testid="landing-tagline" className="font-serif text-3xl font-bold leading-tight tracking-tight whitespace-nowrap">
            Your MindMoves You.
          </h1>
          <p className="text-white/70 text-lg mt-5 leading-relaxed">
            Train your mind like you train your body. Improve your game in one week — become a hero in 30 days.
          </p>

          <ul className="mt-7 space-y-3 text-white/80 text-[15px]">
            {["AI-written, voice-guided visualizations", "Personalized to your sport & position", "Daily check-ins, journaling & streaks"].map((t) => (
              <li key={t} className="flex items-center gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-turq" /> {t}
              </li>
            ))}
          </ul>
        </div>

        <div className="relative z-10 space-y-3 mt-12">
          <button data-testid="get-started-btn" onClick={() => navigate("/login?mode=register")}
            className="w-full bg-white text-navy font-bold py-4 rounded-2xl flex items-center justify-center gap-2 active:scale-[0.98] transition-transform">
            Get started <ArrowRight size={18} />
          </button>
          <button data-testid="have-account-btn" onClick={() => navigate("/login")}
            className="w-full bg-white/10 border border-white/15 text-white font-semibold py-3.5 rounded-2xl active:scale-[0.98] transition-transform">
            I already have an account
          </button>
          <p className="text-center text-white/40 text-[11px] pt-1">
            13+ only. Supportive wellness — not medical advice.
          </p>
        </div>
      </div>
    </div>
  );
}
